import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loading } from "@/components/Feedback";

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) return <Loading full label="Vérification de la session…" />;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/accueil" replace />;
  return children;
};
